import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import BasicButton from "@components/button/BasicButton";
import { useNavigate, useParams } from "react-router-dom";

const SuccessStockRegister = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id, status } = useParams();

  const handleNavigate = () => {
    navigate(`/product-detail/${id}/${status}`, {
      replace: true,
    });
  };

  return (
    <Container>
      <ContentBox>
        <Image src={theme.image.check_circle.default} size="6rem" />
        <span>재고 등록이 완료되었습니다</span>
        <Descriptions>등록된 재고상품은 상품 상세페이지에서 확인할 수 있습니다.</Descriptions>
      </ContentBox>

      <ButtonWrapper>
        <BasicButton
          title="다른 상품 등록하기"
          width="100%"
          height="5.2rem"
          transparent
          onClick={() => navigate("/capture-list", { replace: true })}
        />

        <BasicButton
          title="상품 상세 페이지로 이동하기"
          width="100%"
          height="5.2rem"
          transparent
          onClick={handleNavigate}
        />
      </ButtonWrapper>
    </Container>
  );
};

export default SuccessStockRegister;

const Container = styled.div({
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

const ContentBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "2rem",
  fontSize: "2.4rem",
  fontWeight: theme.fontWeight.medium,
  flex: 1,
  marginTop: "20rem",
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  width: "100%",
  zIndex: 10,
  padding: "2rem",
}));

const Descriptions = styled.span(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
  lineHeight: "21px",
}));
